import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = true

// stimulus controllers
import "~/javascript/controllers"

// import "channels"

// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()

// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Polyfills
import "inert-polyfill"
import 'element-matches-polyfill'
import 'dwnld-attr-polyfill'
import 'parent-node-prepend-polyfill'
import 'matchmedia-polyfill'
import ObjectAssign from 'es6-object-assign'

ObjectAssign.polyfill();

// Website specific
import DisclosureWidget from "~/javascript/disclosure-widget"
import ScrollbarWidth from "~/javascript/scrollbar-width"
import ARIAaccordion from '~/javascript/aria-accordion'
import ARIAtabs from "~/javascript/aria-tabs"
import ARIAtables from "~/javascript/aria-tables"
import ARIAslider from "~/javascript/aria-slider"
import GuidelineOrderFormDownload from "~/javascript/guideline_order_form_download"
import EventRegistrationSubmit from "~/javascript/event_registration_submit"
import { initCookieConsent } from "~/javascript/cookie_consent"
import { initAnalyticsEvents } from "~/javascript/analytics_events"
import "~/javascript/din_order_form"

import "@oddcamp/cocoon-vanilla-js"
import HesGallery from "hes-gallery"

initCookieConsent();
initAnalyticsEvents();

document.addEventListener("turbo:load", function() {
  HesGallery.init()
  EventRegistrationSubmit.start()
  GuidelineOrderFormDownload.start()
  DisclosureWidget.start()
  ARIAtabs.start()
  ARIAaccordion.start()
  ARIAtables.start()
  ARIAslider.start()
  ScrollbarWidth.start()
});
